import {IRawChat} from '../RawChat';

export default function isRaisingChat(currentChat: IRawChat, updatedChat: IRawChat) {
  return updatedChat.lastMessageSentAt && currentChat.lastMessageSentAt?.lessThan(updatedChat.lastMessageSentAt);
}
